export const isTreesCountSet = (state) => {
    return state.treesCount.count !== null && state.treesCount.effectiveness !== null;
}

export const treesCount = (state) => {
    return state.treesCount;
};
